import z from "zod";
import { baseEntitySchema } from "./base";
import { ProductType } from "./product";

export enum DiscountType {
  PERCENTAGE = "percentage",
  FIXED = "fixed",
}

export const PromoCodeDataSchema = z.object({
  name: z.string(),
  code: z.string(),
  discount: z.object({
    type: z.nativeEnum(DiscountType),
    value: z.number(),
  }),
  expirationDate: z.date().optional(),
  enabledFor: z.nativeEnum(ProductType),
});

export type PromoCodeData = z.infer<typeof PromoCodeDataSchema>;
export const promoCodeSchema = baseEntitySchema.extend(PromoCodeDataSchema.shape);
export type PromoCode = z.infer<typeof promoCodeSchema>;
